import { render } from "./index.vue?vue&type=template&id=e83ef27a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e83ef27a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e83ef27a"],['__file',"src/views/ResetPassword/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e83ef27a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e83ef27a', __exports__)) {
    console.log('reload')
    api.reload('e83ef27a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=e83ef27a&scoped=true", () => {
    console.log('re-render')
    api.rerender('e83ef27a', render)
  })

}


export default __exports__